import { useTranslations } from 'next-intl';

export function ChatbotFeedbackSuccessPopup() {
  const t = useTranslations('features');

  return (
    <>
      <div className="text-sm mb-4 whitespace-break-spaces w-[370px]">{t('ai-helper.it_will_help_improve')}</div>
      <img src="/assets/img/ai-feedback-success-popup.png" alt={t('ai-helper.request_has_been_accepted')} />
    </>
  );
}
